// Launch KaziPeople Web from any owning surface (Work, Conversations, …) with a
// resource URL and a Work Context. The browser is domain-neutral: the source domain
// stays the system of record; we only hand the browser a *reference* (WorkContext)
// plus the URL to open, and a route to return to. Receiving side: WebPage.useLaunchContext.
import type { NavigateFunction } from 'react-router-dom';
import type { WorkContext } from './types';

// Derive the tenant-scoped `/…/app/web` route from any in-app pathname
// (e.g. `/t/demo/app/work/items/42` → `/t/demo/app/web`).
export function webRouteFrom(pathname: string): string {
  const m = pathname.match(/^(.*\/app)(?:\/|$)/);
  if (m) return `${m[1]}/web`;
  // Fallback: swap the last path segment for `web`.
  return pathname.replace(/\/[^/]*\/?$/, '/web');
}

export interface LaunchWebOptions {
  url?: string;
  context?: WorkContext;
}

// Navigate to KaziPeople Web. The URL rides as a query param (the receiver reads
// `?url=`); the context rides in navigation state (kept out of the address bar), with
// the current route recorded as sourceRoute so the context panel can offer "return".
export function launchWeb(
  navigate: NavigateFunction,
  pathname: string,
  { url, context }: LaunchWebOptions,
): void {
  const base = webRouteFrom(pathname);
  const search = url ? `?url=${encodeURIComponent(url)}` : '';
  const state = context
    ? { workContext: { sourceRoute: pathname, ...context } }
    : undefined;
  navigate(`${base}${search}`, state ? { state } : undefined);
}
